import "./style.scss";
function Footer() {
    return (
        <div className="footer-section">
            <p>
                Created By{" "}
                <a href="https://github.com/DenisMoldovanu" target="blank">
                    Denis
                </a>
            </p>
        </div>
    );
}

export default Footer;
